module.exports = __webpack_public_path__ + "img/sony_bucks_logo.c3dad7ce.png";